<template>
  <div class="tabs" v-on:touchstart.stop v-on:touchmove.stop>
    <template v-for="(item, index) in tabs">
      <Tab :key="index" :info="item" :currentTab="currentTab" @click.native="tabClick(item.type)">
      </Tab>
    </template>
    <template v-for="(item, index) in oprationingPositions">
      <Oprationing :key="'Oprationing'+index" v-if="oprationingPositions!=null" :data="item" @click.native="jumpUrl(item)"></Oprationing>
    </template>
  </div>
</template>
<style lang="less" scoped>
.tabs {
  display: inline-flex;
  padding: 12px;
  box-sizing: border-box;
  width: 100%;
  overflow-y: hidden;
  overflow-x: scroll;
}
</style>
<script>
import Tab from './tab.vue';
import { Tabs } from '@/config/tabs'

import Oprationing from '@/components/Home/oprationing.vue'
export default {
  name: 'Tabs',
  props: ['currentTab','oprationingPositions'],
  data() {
    return {
      tabs: Tabs,
    };
  },
  components: {
    Tab,
    Oprationing
  },
  methods: {
    setBannerSa({name = 'Live', type, id}) {
      this.sa.track({
        eventId: 'userClickBanner',
        eventParam: {
          bannerName: name,
          bannerType: type==0?'搜索专题运营位':'',
          bannerID: id
        }
      });
    },
    tabClick(type) {
      this.$emit('tabchange', type);
    },
    jumpUrl(item){
      this.setBannerSa(item)
      setTimeout(function(){
        window.location.href = item.url
      },500);
    }
  }
};
</script>
